import React, { useState } from "react";
import TrainLoader from '../General/TrainLoader';

const NBLMGuide = () => {
  const [loaded, setLoaded] = useState(false);

  const spinnerContainerStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
  };

  return (
    <div style={{ width: "100%", height: "100%", minHeight: "100vh" }}>
      {!loaded && (
        <div style={spinnerContainerStyle}>
          <TrainLoader />
        </div>
      )}
      <iframe
        src="https://scribehow.com/embed/NotebookLM_for_RFP_Documents__lc-_QJJPTF-Xfu0e_iI3Eg?skipIntro=true&removeLogo=true&as=scrollable"
        width="100%"
        height="800"
        allow="fullscreen"
        style={{ border: 0, minHeight: '640px' }}
        title="NBLM Guide"
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default NBLMGuide;
